export const TableDateFormat = 'DD/MM/YY';
export const TableDateTimeFormat = 'DD/MM/YY, HH:mm';

export const ExportDateFormat = 'DD-MM-YY HH-mm-ss';

export const ApiDateFilterFormat = 'YYYY-MM-DD';
